export default __webpack_public_path__ + "static/media/avatar_arrow_boy1.bf112d0b.mp3";